export default "__VITE_ASSET__CAwSTm$g__"